export enum MobileMenuType {
  main = 'main',
  payment = 'payment',
}
